var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},[React.createElement("path",{"d":"M32 17.133c1.188 0 2.17.883 2.326 2.028l.021.319v14.085a2.347 2.347 0 01-4.673.319l-.022-.319V19.48A2.347 2.347 0 0132 17.132z","key":0}),React.createElement("path",{"d":"M43.496 33.389c0 1.188-.883 2.17-2.029 2.326l-.319.021h-9.39a2.348 2.348 0 01-.318-4.673l.318-.022h9.39a2.348 2.348 0 012.348 2.348z","key":1}),React.createElement("path",{"d":"M32 5.395c14.694 0 26.605 11.911 26.605 26.605S46.694 58.605 32 58.605 5.395 46.694 5.395 32 17.306 5.395 32 5.395zm0 4.695c-12.1 0-21.91 9.81-21.91 21.91S19.9 53.91 32 53.91 53.91 44.1 53.91 32 44.1 10.09 32 10.09z","key":2})]));
}

Time.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Time;

Time.default = Time;
